import _ from "lodash"
import { T予算実績 } from "../../../service/budget/sogoYusoKaigi/TSogoYusoKaigi"

// 行がなかったとき用の0埋め用変数
const allZero予算実績: T予算実績 = {
  年月: "",
  部所コード: "",
  部所名: "",
  項目: "",
  年間金額: 0,
  上期金額: 0,
  下期金額: 0,
  金額４月: 0,
  金額５月: 0,
  金額６月: 0,
  金額７月: 0,
  金額８月: 0,
  金額９月: 0,
  金額１０月: 0,
  金額１１月: 0,
  金額１２月: 0,
  金額１月: 0,
  金額２月: 0,
  金額３月: 0,
} as const

export const 予算実績列項目文字列 = {
  予算: "予算",
  当年実績: "当年実績",
  前年実績: "前年実績",
  達成率: "達成率",
  運行実績: "運行実績",
} as const

export const 予算実績列項目ソート番号List: {
  [name in keyof typeof 予算実績列項目文字列]: number
} = {
  予算: 1,
  当年実績: 2,
  前年実績: 3,
  達成率: 4,
  運行実績: 5,
}

export const orderBy総合輸送会議予算実績 = (gridRowData: T予算実績[]) =>
  _.orderBy(gridRowData, [
    "部所コード",
    (a) => {
      const a項目 = a.項目 as keyof typeof 予算実績列項目文字列
      const aIndex = 予算実績列項目ソート番号List[a項目] ?? 0
      return aIndex
    },
  ])

export const 粗利益列項目文字列 = {
  売上: "売上",
  変動費: "変動費",
  粗利益: "粗利益",
  利益率: "利益率",
} as const

export const create総合輸送会議部所実績合算Data = (
  予算実績List: T予算実績[],
  項目名: keyof typeof 予算実績列項目文字列,
  共通項目?: {
    年月: string
    部所コード: string
    部所名: string
  }
): T予算実績 => {
  const gridRowData = 予算実績List.filter((f) => f.項目 === 項目名)

  return gridRowData.length > 0
    ? {
        年月: 共通項目?.年月 ?? "",
        部所コード: 共通項目?.部所コード ?? "",
        部所名: 共通項目?.部所名 ?? "",
        項目: 項目名,
        年間金額: gridRowData
          .map((m) => m.年間金額)
          .reduce((a, b) => (a ?? 0) + (b ?? 0)),
        上期金額: gridRowData
          .map((m) => m.上期金額)
          .reduce((a, b) => (a ?? 0) + (b ?? 0)),
        下期金額: gridRowData
          .map((m) => m.下期金額)
          .reduce((a, b) => (a ?? 0) + (b ?? 0)),
        金額４月: gridRowData.map((m) => m.金額４月).reduce((a, b) => a + b),
        金額５月: gridRowData.map((m) => m.金額５月).reduce((a, b) => a + b),
        金額６月: gridRowData.map((m) => m.金額６月).reduce((a, b) => a + b),
        金額７月: gridRowData.map((m) => m.金額７月).reduce((a, b) => a + b),
        金額８月: gridRowData.map((m) => m.金額８月).reduce((a, b) => a + b),
        金額９月: gridRowData.map((m) => m.金額９月).reduce((a, b) => a + b),
        金額１０月: gridRowData
          .map((m) => m.金額１０月)
          .reduce((a, b) => a + b),
        金額１１月: gridRowData
          .map((m) => m.金額１１月)
          .reduce((a, b) => a + b),
        金額１２月: gridRowData
          .map((m) => m.金額１２月)
          .reduce((a, b) => a + b),
        金額１月: gridRowData.map((m) => m.金額１月).reduce((a, b) => a + b),
        金額２月: gridRowData.map((m) => m.金額２月).reduce((a, b) => a + b),
        金額３月: gridRowData.map((m) => m.金額３月).reduce((a, b) => a + b),
      }
    : {
        ...allZero予算実績,
        年月: "",
        部所コード: "",
        部所名: "",
        項目: 項目名,
      }
}

export const create総合輸送会議粗利益集計Data = (
  予算実績List: T予算実績[],
  項目名: keyof typeof 粗利益列項目文字列
): T予算実績 => {
  const gridRowData = 予算実績List.filter((f) => f.項目 === 項目名)

  return gridRowData.length > 0
    ? {
        年月: "",
        部所コード: "",
        部所名: "全社",
        項目: 項目名,
        年間金額: gridRowData
          .map((m) => m.年間金額)
          .reduce((a, b) => (a ?? 0) + (b ?? 0)),
        上期金額: gridRowData
          .map((m) => m.上期金額)
          .reduce((a, b) => (a ?? 0) + (b ?? 0)),
        下期金額: gridRowData
          .map((m) => m.下期金額)
          .reduce((a, b) => (a ?? 0) + (b ?? 0)),
        金額４月: gridRowData.map((m) => m.金額４月).reduce((a, b) => a + b),
        金額５月: gridRowData.map((m) => m.金額５月).reduce((a, b) => a + b),
        金額６月: gridRowData.map((m) => m.金額６月).reduce((a, b) => a + b),
        金額７月: gridRowData.map((m) => m.金額７月).reduce((a, b) => a + b),
        金額８月: gridRowData.map((m) => m.金額８月).reduce((a, b) => a + b),
        金額９月: gridRowData.map((m) => m.金額９月).reduce((a, b) => a + b),
        金額１０月: gridRowData
          .map((m) => m.金額１０月)
          .reduce((a, b) => a + b),
        金額１１月: gridRowData
          .map((m) => m.金額１１月)
          .reduce((a, b) => a + b),
        金額１２月: gridRowData
          .map((m) => m.金額１２月)
          .reduce((a, b) => a + b),
        金額１月: gridRowData.map((m) => m.金額１月).reduce((a, b) => a + b),
        金額２月: gridRowData.map((m) => m.金額２月).reduce((a, b) => a + b),
        金額３月: gridRowData.map((m) => m.金額３月).reduce((a, b) => a + b),
      }
    : {
        ...allZero予算実績,
        年月: "",
        部所コード: "",
        部所名: "全社",
        項目: 項目名,
      }
}
